import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const team = () => {

	const section = document.querySelector('[data-function="team"]')

	if (!section) return

	let buttons = section.querySelectorAll('[data-filter]'),
		items = section.querySelectorAll('[data-member]')

	buttons.forEach(button => {
		button.addEventListener('click', () => {
			const category = button.dataset.filter

			buttons.forEach(b => b.removeAttribute('data-status'));
			button.setAttribute('data-status', 'active');

			items.forEach(item => {
				if (category === 'all' || item.dataset.member.includes(category)) {
					item.style.display = ''
					item.classList.remove('hidden')
				} else {
					item.style.display = 'none'
					item.classList.add('hidden')
				}
			})

			ScrollTrigger.refresh()
		})
	})
}

export default () => { }